document.addEventListener('DOMContentLoaded',function(){
  if(!location.pathname.includes('bedruckte-armbander-fertig-konfektioniert'))return;
  var quantity=document.querySelector('input[name="quantity"]');
  var form=document.querySelector('.config-form');
  if(!quantity||!form)return;
  quantity.min='25';
  if(Number(quantity.value)<25)quantity.value='25';
  function validate(){
    var invalid=Number(quantity.value)<25;
    quantity.setCustomValidity(invalid?'Die Mindestbestellmenge beträgt 25 Stück.':'');
    return !invalid;
  }
  quantity.addEventListener('input',validate);
  form.addEventListener('submit',function(event){
    if(!validate()){
      event.preventDefault();
      quantity.reportValidity();
    }
  });
});
